module.exports = __webpack_public_path__ + "static/media/290085.ab1c66b8.png";